/**
 * Zod schemas for file import validation.
 * Used for client-side header validation before upload.
 */
import { z } from 'zod'

/** Required column headers that must be present in import files */
export const REQUIRED_IMPORT_HEADERS = ['transaction_date', 'amount', 'description', 'facility', 'bank_account_name', 'bank_account_number'] as const

/** All recognized column headers for import files */
export const ALL_IMPORT_HEADERS = [
  'transaction_date',
  'amount',
  'description',
  'facility',
  'category',
  'bank_account_name',
  'bank_account_number',
  'vendor',
  'currency',
  'type',
] as const

/**
 * Schema for validating that required headers are present in an import file.
 * Normalizes headers to lowercase and trims whitespace before checking.
 */
export const importHeadersSchema = z.object({
  headers: z.array(z.string()).refine(
    (headers) => {
      const normalized = headers.map(h => h.trim().toLowerCase())
      return REQUIRED_IMPORT_HEADERS.every(required => normalized.includes(required))
    },
    {
      message: `Missing required columns. Required: ${REQUIRED_IMPORT_HEADERS.join(', ')}`,
    },
  ),
})
